var site_key, rcCallback;
jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
function canUseWebP() {
    var elem = document.createElement('canvas');
    if (!!(elem.getContext && elem.getContext('2d'))) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    return false;
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function pseudoYoutube(element) {
    if (!$('body').data('youtubeApi')) {
        $('body').data('youtubeApi', true);
        $.getScript('https://www.youtube.com/iframe_api', function () {
            setTimeout(pseudoYoutube, 500, element);
        });

    } else {
        var youtubeID = $(element).data('id');
        var containerID = $(element).attr('id');
        $(element).html('');
        var player = new YT.Player(containerID, {
            videoId: youtubeID,
            events: {
                'onReady': function (event) {
                    event.target.playVideo();
                    $(event.target.i).data('player', event.target);
                }
            }
        });
        $('#'+containerID).data('player', player);
    }
}

function passUtmsToIframe() {
    if (window.location.search) {
        const urlParams = new URLSearchParams(window.location.search);
        var iframes = document.querySelectorAll('iframe').length;
        if (iframes === 1) {
            var utms = [
                "utm_medium=" + urlParams.get('utm_medium'),
                "utm_source=" + urlParams.get('utm_source'),
                "utm_campaign=" + urlParams.get('utm_campaign'),
                "utm_term=" + urlParams.get('utm_term'),
                "utm_gclid=" + urlParams.get('utm_gclid'),
                "utm_content=" + urlParams.get('utm_content')
            ];
            document.querySelectorAll('iframe')[0].src = document.querySelectorAll('iframe')[0].src + "?" + utms.join("&");
        }
    }
}

$(function () {
    if ($('#newsletterForm').length) {
        irisValidation($('#newsletterForm'), {
            focusFirstInput: false,
            url: '/wp/wp-admin/admin-ajax.php?action=newsletter_submission',
            validators: {
                newsletterEmail: 'email'
            },
            validateByTimeout: ['newsletterEmail'],
            errorMessages: {
                required: 'Please fill out this field.',
                emailFormat: 'Not a valid email',
                connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
            }
        });
    }

    if (getCookie('cookie_accepted') === '1') {
        if(typeof(tgmgr) != 'undefined') {
            eval(tgmgr);
        }
    } else if (!window.localStorage.getItem('declineCookie')) {
        $('.acceptCookieWindow').removeClass('hidden');
    }
    $('.acceptCookieWindow .accept').on('click', function () {
        setCookie('cookie_accepted', '1', 60);
        $('.acceptCookieWindow').addClass('hidden');
        if(typeof(tgmgr) != 'undefined') {
            eval(tgmgr);
        }
    });
    $('.acceptCookieWindow .decline').on('click', function () {
        window.localStorage.setItem('declineCookie', true);
        $('.acceptCookieWindow').addClass('hidden');
    });
    setTimeout(function () {
        $('body').addClass('loaded');
    }, 0.5);
    if (!canUseWebP()) {
        $('body').addClass('no-webp');
    }
    $('.lazy-script').on('prescrolled', function () {
        console.log($(this).data('script'));
        if ($(this).data('script')) {
            $.getScript($(this).data('script'), function(){
                console.log('loaded');
            });
        }
    });
    $('.lazy-iframe').on('prescrolled', function () {
        if ($(this).data('src')) {
            $(this).attr('src', $(this).data('src'));
            $(this).removeData('src');
            passUtmsToIframe();
        }
    });
    $('.pseudo-youtube').on('click', function () {
        pseudoYoutube(this);
    });

    $('#twitter-widget').on('prescrolled', function () {
        var $height = 510;
        var $width = $(this).closest(".widget").width();

        /* Set widget height on the blog page and tablet resolutions */
        if ($(this).data().location === "blog" && (window.innerWidth > 700 && window.innerWidth < 1200)) {
            $height = 700;
        }
        $('#twitter-widget').append('<a class="twitter-timeline" data-width=' + $width + ' data-height="' + $height + '" href="https://twitter.com/IRIS_CRM?ref_src=twsrc%5Etfw">Tweets by IRIS_CRM</a>');
        $.getScript('https://platform.twitter.com/widgets.js');
    });
    $('form').each(function () {
        if ($(this).find('[name="Referral URL"]').length == 0) {
            $(this).append('<input name="Referral URL" type="hidden" />');
        }
        $(this).find('[name="Referral URL"]').val(window.location.href);
    });

    $(document).on('scroll', function (e) {
        var scroll = $(window).scrollTop();
        var elementScroll = scroll + $(window).height() + 50;
        $('.scrollChecker').each(function () {
            var toHeaderScrollPosition = ($(this).offset().top - $('#navbar').outerHeight() - (($('#wpadminbar').length > 0) ? $('#wpadminbar').outerHeight() : 0));
            if (elementScroll > $(this).offset().top) {
                if (!$(this).hasClass('prescrolled')) {
                    $(this).addClass('prescrolled');
                    $(this).trigger('prescrolled');
                }
            }
            if (elementScroll > ($(this).offset().top + ($(this).height() * 0.9)) && scroll < $(this).offset().top + ($(this).height() * 0.1)) {
                if (!$(this).hasClass('scrolled')) {
                    $(this).addClass('scrolled');
                    $(this).trigger('scrolled');
                }
            }
            if (scroll > toHeaderScrollPosition) {
                if (!$(this).hasClass('stickyheader')) {
                    $(this).addClass('stickyheader');
                    $(this).trigger('stickyheader:on');
                }
            }
            if (scroll <= toHeaderScrollPosition) {
                if ($(this).hasClass('stickyheader')) {
                    $(this).removeClass('stickyheader');
                    $(this).trigger('stickyheader:off');
                }
            }
        });
    });
    $(document).trigger('scroll');
    $(document).on('shown.bs.modal', function (e) {
        $(e.target).find('input:not([type="hidden"])').first().trigger('focus');
    });

    var i = 0;

    $('iframe').each(function(){
        var iframe = this;

        $(iframe).attr('data-loads', 0 );

        $(iframe).on('load',function(){

            $(iframe).attr('data-loads', parseInt($(iframe).attr('data-loads')) + parseInt(1));

            if ( $(iframe).attr('data-loads') > 1 ) {
                iframe.scrollIntoView();
            }
        });
    });

    $(document).ready(function (){
        passUtmsToIframe();
    });
});

